import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入ant-design-vue
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import * as antIcons from '@ant-design/icons-vue'

// 导入axios
import axios from 'axios'
axios.defaults.withCredentials = true;

// 导入字体
import '@/assets/fonts/fonts.css';
// 导入样式
import '@/assets/styles/basic.css';
import '@/assets/styles/page.scss';
import '@/assets/styles/title.css';

const app = createApp(App);

// 注册ant-design-vue图标组件
Object.keys(antIcons).forEach(key => {
    app.component(key, antIcons[key])
});
// ant-design-vue图标添加到全局
app.config.globalProperties.$antIcons = antIcons;

//axios添加到全局
app.config.globalProperties.$axios = axios;

app.use(store).use(router).use(Antd).mount('#app')
